import { useSyncExternalStore } from 'react';

/** How many of the voice's latest words a call view is handed. */
const KEPT = 24;

/**
 * The words the call's voice says, in order, as its transcript streams them (each with an id
 * that grows): a call view shapes its mouth with them. Kept out of React state like the level:
 * only the call's face follows them.
 */
let spoken: readonly { id: number; text: string }[] = [];
let next = 1;
const listeners = new Set<() => void>();
const changed = () => {
  for (const listener of listeners) listener();
};

export function addCallSpeech(text: string): void {
  if (!text) return;
  spoken = [...spoken.slice(1 - KEPT), { id: next++, text }];
  changed();
}

export function clearCallSpeech(): void {
  if (spoken.length === 0) return;
  spoken = [];
  changed();
}

export function useCallSpeech(): readonly { id: number; text: string }[] {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => spoken,
    () => spoken,
  );
}
